module.exports = __webpack_public_path__ + "img/logo-long.e935d353.png";